<ion-button (click)="cancel.emit()">
    <ion-icon slot="icon-only" icon="close-circle-outline"></ion-icon>
</ion-button>

<div class="inner-content">
    <ng-content></ng-content>
</div>